export default "__VITE_ASSET__K5uJ2n39__$_?nuxt_component=async&nuxt_component_name=IconUpdownGray&nuxt_component_export=default__"